import { create } from 'zustand';

type WalletVisibilityStoreType = {
  isWalletAmountHidden: boolean;
  toggleWalletAmountVisibility: () => void;
};

export const useWalletVisibilityStore = create<WalletVisibilityStoreType>((set) => ({
  isWalletAmountHidden: false,
  toggleWalletAmountVisibility: () => set((state) => ({ isWalletAmountHidden: !state.isWalletAmountHidden })),
}));
